import React from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik-2';
import { partnerShape, siteShape, templateShape } from '../types';
import AppAutocomplete from './AppAutocomplete';
import css from './AppSelection.css';
import { AUTOCOMPLETE_LAYOUTS } from '../../../components/molecules/AutoCompleteField';

const AppSelection = ({
    partner,
    disabled = false,
    sites = [],
    postbackTemplates = [],
    onChange: onChangeProp = () => {},
    layout = AUTOCOMPLETE_LAYOUTS.VERTICAL,
    selectedAgencyId = '',
    showEmptyState = true,
}) => {
    const { values, setValues, setTouched } = useFormikContext();

    const onChange = ({ value }) => {
        if (values.site === value) return;

        setValues({ site: value }); // clear form values
        setTouched({ site: true });

        onChangeProp(value);
    };

    return (
        <AppAutocomplete
            label="STATIC.APP_SITE"
            labelClassName={css.fixedLabelWidth}
            partner={partner}
            disabled={disabled}
            sites={sites}
            postbackTemplates={postbackTemplates}
            onChange={onChange}
            layout={layout}
            selectedAgencyId={selectedAgencyId}
            showEmptyState={showEmptyState}
        />
    );
};

AppSelection.propTypes = {
    partner: partnerShape.isRequired,
    disabled: PropTypes.bool,
    sites: PropTypes.arrayOf(siteShape),
    postbackTemplates: PropTypes.arrayOf(templateShape),
    onChange: PropTypes.func,
    selectedAgencyId: PropTypes.string,
    layout: PropTypes.oneOf(Object.values(AUTOCOMPLETE_LAYOUTS)),
    showEmptyState: PropTypes.bool,
};

export default AppSelection;
